import { Column } from 'further-ui/components/Layout';
import { FC } from 'react';
import FormField from 'further-ui/components/FormField';
import { TextField } from '@mui/material';
import { FirmBankDetailsSelector } from 'components/FirmBankDetailsSelector';
import CkEditor from 'components/CkEditor';
import { Control, Controller } from 'react-hook-form';
import { TrancheFormInput } from '../../useTrancheForm';
import { TrancheDotColor } from '../dotColors';

type Props = {
  control: Control<TrancheFormInput>;
  firmId: string;
  showDraftDots: boolean;
};

const BankDetails: FC<Props> = ({ control, firmId, showDraftDots }) => {
  const draftDotColor = showDraftDots ? TrancheDotColor.Draft : undefined;
  return (
    <Column spacing="lg" fullWidth>
      <FormField
        label="Select payment account"
        size="md"
        tooltip="To add a new bank account, navigate to the Bank accounts section of your Firm Settings page."
        dotColor={draftDotColor}
      >
        <Controller
          control={control}
          name="firmBankDetailId"
          render={({ field, fieldState }) => (
            <FirmBankDetailsSelector
              firmId={firmId}
              onChange={field.onChange}
              placeholder="Select payment account"
              currentValue={field.value}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </FormField>
      <FormField
        label="Custom reference"
        size="md"
        tooltip="By default, the system automatically generates a unique bank transfer reference for each investor. If you want investors to follow a specific format instead, please input this here for investors to see alongside your bank account details. Please note that if any text is input here, it will override the system's automatic payment reference creation feature."
      >
        <Controller
          control={control}
          name="customBankTransferReference"
          render={({ field }) => (
            <TextField
              fullWidth
              size="small"
              placeholder="Enter custom reference"
              value={field.value}
              onChange={(e) => field.onChange(e.target.value)}
            />
          )}
        />
      </FormField>
      <FormField
        extraInformation="This helper text appears on the bank transfer payment page, alongside bank details."
        label="Payment helper text"
        size="xl"
      >
        <Controller
          control={control}
          name="title"
          render={({ field }) => (
            <CkEditor
              placeholder="Enter payment helper text"
              onChange={field.onChange}
              value={field.value}
              extraLines={7}
            />
          )}
        />
      </FormField>
    </Column>
  );
};

export default BankDetails;
